export default __webpack_public_path__ + "media/titles/title_5_locale_pt-6dbab88f.png";